// StateViewTable.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import "./StateViewTable.css";
import * as XLSX from "xlsx";
import StateViewCharts from "./StateViewCharts"; // new import

const StateViewTable = ({ filters }) => {
  const [tableData, setTableData] = useState([]);
  const [dflData, setDflData] = useState([]);
  const [ycData, setYcData] = useState([]);
  const [isLoadingDI, setIsLoadingDI] = useState(true);
  const [isLoadingDFL, setIsLoadingDFL] = useState(true);
  const [isLoadingYC, setIsLoadingYC] = useState(true);
  const [citizenData, setCitizenData] = useState([]);
  const [isLoadingCitizen, setIsLoadingCitizen] = useState(true);
  const [msmeData, setMsmeData] = useState([]);
  const [isLoadingMSME, setIsLoadingMSME] = useState(true);
  const [hdData, setHdData] = useState([]);
  const [isLoadingHD, setIsLoadingHD] = useState(true);
  const [hdTrainedData, setHdTrainedData] = useState([]);
  const [isLoadingHDTrained, setIsLoadingHDTrained] = useState(true);
  const [trainersData, setTrainersData] = useState([]);
const [isLoadingTrainers, setIsLoadingTrainers] = useState(true);
const [MSMEReachedData, setMSMEReachedData] = useState([]);
const [isLoadingMSMEReached, setIsLoadingMSMEReached] = useState(true);
const [benefitValueData, setBenefitValueData] = useState([]);
const [isLoadingBenefitValue, setIsLoadingBenefitValue] = useState(true);

const [showCharts, setShowCharts] = useState(false);

  useEffect(() => {
    const query = new URLSearchParams(filters).toString();

    setIsLoadingDI(true);
    setIsLoadingDFL(true);
    setIsLoadingYC(true);

    axios
      .get(`https://api-usersreport-insights.haqdarshak.com/api/ar-di-agg?${query}`)
      .then((res) => setTableData(res.data))
      .catch((err) => console.error(err))
      .finally(() => setIsLoadingDI(false));

    axios
      .get(`https://api-usersreport-insights.haqdarshak.com/api/ar_dfl_agg?${query}`)
      .then((res) => setDflData(res.data))
      .catch((err) => console.error("DFL Fetch Error:", err))
      .finally(() => setIsLoadingDFL(false));

    axios
      .get(`https://api-usersreport-insights.haqdarshak.com/api/ar_yc_agg?${query}`)
      .then((res) => setYcData(res.data))
      .catch((err) => console.error("YC Fetch Error:", err))
      .finally(() => setIsLoadingYC(false));

      axios
  .get(`https://api-usersreport-insights.haqdarshak.com/api/citizen-data?${query}`)
  .then((res) => setCitizenData(res.data))
  .catch((err) => console.error("Citizen Fetch Error:", err))
  .finally(() => setIsLoadingCitizen(false));

  axios.get(`https://api-usersreport-insights.haqdarshak.com/api/msme-data?${query}`)
      .then((res) => setMsmeData(res.data))
      .catch((err) => console.error("MSME Fetch Error:", err))
      .finally(() => setIsLoadingMSME(false));

      axios
  .get(`https://api-usersreport-insights.haqdarshak.com/api/hd-activity?${query}`)
  .then((res) => setHdData(res.data))
  .catch((err) => console.error("HD Fetch Error:", err))
  .finally(() => setIsLoadingHD(false));

  axios
  .get(`https://api-usersreport-insights.haqdarshak.com/api/hd-trained?${query}`)
  .then((res) => setHdTrainedData(res.data))
  .catch((err) => console.error("HD Trained Fetch Error:", err))
  .finally(() => setIsLoadingHDTrained(false));

  axios
  .get(`https://api-usersreport-insights.haqdarshak.com/api/trainers-trained?${query}`)
  .then((res) => setTrainersData(res.data))
  .catch((err) => console.error("Trainers Trained Fetch Error:", err))
  .finally(() => setIsLoadingTrainers(false));

  axios
  .get(`https://api-usersreport-insights.haqdarshak.com/api/msme-reached?${query}`)
  .then((res) => setMSMEReachedData(res.data))
  .catch((err) => console.error("MSME Reached Fetch Error:", err))
  .finally(() => setIsLoadingMSMEReached(false));

  axios
    .get(`https://api-usersreport-insights.haqdarshak.com/api/benefits-value?${query}`)
    .then((res) => setBenefitValueData(res.data))
    .catch((err) => console.error("Benefit Value Fetch Error:", err))
    .finally(() => setIsLoadingBenefitValue(false));

  }, [filters]);

  const renderLoadingRow = (colSpan = 11) => (
    <tr>
      <td colSpan={colSpan} className="loading-cell">
        Loading data...
      </td>
    </tr>
  );

  const getPercentageClass = (value) => {
    if (value === null || value === undefined || value === "") return "";
    const num = parseFloat(value);
    if (isNaN(num)) return "";
    if (num > 0) return "text-green";
    if (num < 0) return "text-red";
    return "";   
  };

  const exportToExcel = (data, fileName = "table_data") => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };


  
  return (
    <div className="table-container3">
      <h3 className="table-title">State-wise Performance View</h3>

      {/* DI Table */}
      {/* Toggle Buttons - Always Visible */}
<div className="view-toggle">
  <button className={`toggle-btn ${!showCharts ? 'active' : ''}`} onClick={() => setShowCharts(false)}>Tables</button>
  <button className={`toggle-btn ${showCharts ? 'active' : ''}`} onClick={() => setShowCharts(true)}>Charts</button>
</div>

{/* Charts Section */}
{showCharts ? (
  <StateViewCharts
    tableData={tableData}
    dflData={dflData}
    ycData={ycData}
    citizenData={citizenData}
    msmeData={msmeData}
    hdData={hdData}
    hdTrainedData={hdTrainedData}
    trainersData={trainersData}
    MSMEReachedData={MSMEReachedData}
    benefitValueData={benefitValueData}
  />
) : (
  <>
    {/* Show DI Table only if data exists */}
    {/* DI Table with This Week Columns */}
{!isLoadingDI && tableData.length > 0 && (
  <>
    <button className="export-btn" onClick={() => exportToExcel(tableData, "DI_Data")}>Export DI Table</button>

    <div className="scroll-table-wrapper">
      <table className="achievement-table">
        <thead>
          <tr className="sticky-header-top">
            <th className="sticky-header sticky-left" rowSpan="2">State</th>
            <th colSpan="4">DI Open</th>
            <th colSpan="4">DI DS</th>
            <th colSpan="4">DI BR</th>
          </tr>
          <tr className="sticky-header-second">
            <th className="sticky-header">Achieved till date</th>
            <th className="sticky-header">Achieved Last Calender Week</th>
            <th className="sticky-header">Achieved This Calender Week</th>
            <th className="sticky-header">% change</th>

            <th className="sticky-header">Achieved till date</th>
            <th className="sticky-header">Achieved Last Calender Week</th>
            <th className="sticky-header">Achieved This Calender Week</th>
            <th className="sticky-header">% change</th>

            <th className="sticky-header">Achieved till date</th>
            <th className="sticky-header">Achieved Last Calender Week</th>
            <th className="sticky-header">Achieved This Calender Week</th>
            <th className="sticky-header">% change</th>
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, index) => (
            <tr key={index}>
              <td className="sticky-left">{row.state}</td>

              {/* DI Open */}
              <td>{row.total_applications_open_DI}</td>
              <td>{row.open_last_week_DI}</td>
              <td>{row.this_week_open_applications_DI}</td>
              <td className={getPercentageClass(row.open_percentage_change_DI)}>{row.open_percentage_change_DI}</td>

              {/* DI DS */}
              <td>{row.total_applications_submitted_DI}</td>
              <td>{row.submitted_last_week_DI}</td>
              <td>{row.this_week_DS_DI}</td>
              <td className={getPercentageClass(row.submitted_percentage_change_DI)}>{row.submitted_percentage_change_DI}</td>

              {/* DI BR */}
              <td>{row.total_br_DI}</td>
              <td>{row.br_last_week_DI}</td>
              <td>{row.this_week_BR_DI}</td>
              <td className={getPercentageClass(row.br_percentage_change_DI)}>{row.br_percentage_change_DI}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </>
)}

  </>
)}


{!showCharts && (
  <>
        {/* DFL Table */}
     {/* DFL Table with This Week Columns */}
{!isLoadingDFL && dflData.length > 0 && (
  <>
    <button className="export-btn" onClick={() => exportToExcel(dflData, "DFL_Data")}>Export DFL Table</button>

    <div className="scroll-table-wrapper">
      <table className="achievement-table">
        <thead>
          <tr className="sticky-header-top">
            <th className="sticky-header sticky-left" rowSpan="2">State</th>
            <th colSpan="4">DFL Open</th>
            <th colSpan="4">DFL DS</th>
            <th colSpan="4">DFL BR</th>
          </tr>
          <tr className="sticky-header-second">
            <th className="sticky-header">Achieved till date</th>
            <th className="sticky-header">Achieved Last Calender Week</th>
            <th className="sticky-header">Achieved This Calender Week</th>
            <th className="sticky-header">% change</th>

            <th className="sticky-header">Achieved till date</th>
            <th className="sticky-header">Achieved Last Calender Week</th>
            <th className="sticky-header">Achieved This Calender Week</th>
            <th className="sticky-header">% change</th>

            <th className="sticky-header">Achieved till date</th>
            <th className="sticky-header">Achieved Last Calender Week</th>
            <th className="sticky-header">Achieved This Calender Week</th>
            <th className="sticky-header">% change</th>
          </tr>
        </thead>
        <tbody>
          {dflData.map((row, index) => (
            <tr key={index}>
              <td className="sticky-left">{row.state}</td>
              <td>{row.total_applications_open_DFL}</td>
              <td>{row.open_last_week_DFL}</td>
              <td>{row.this_week_open_applications_DFL}</td>
              <td className={getPercentageClass(row.open_percentage_change_DFL)}>{row.open_percentage_change_DFL}</td>

              <td>{row.total_applications_submitted_DFL}</td>
              <td>{row.submitted_last_week_DFL}</td>
              <td>{row.this_week_DS_DFL}</td>
              <td className={getPercentageClass(row.submitted_percentage_change_DFL)}>{row.submitted_percentage_change_DFL}</td>

              <td>{row.total_br_DFL}</td>
              <td>{row.br_last_week_DFL}</td>
              <td>{row.this_week_BR_DFL}</td>
              <td className={getPercentageClass(row.br_percentage_change_DFL)}>{row.br_percentage_change_DFL}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </>
)}

</>
    )}

{!showCharts && (
  <>
      {/* YC Table */}
      {/* YC Table with This Week Columns */}
{!isLoadingYC && ycData.length > 0 && (
  <>
    <button className="export-btn" onClick={() => exportToExcel(ycData, "YC_Data")}>Export YC Table</button>

    <div className="scroll-table-wrapper">
      <table className="achievement-table">
        <thead>
          <tr className="sticky-header-top">
            <th className="sticky-header sticky-left" rowSpan="2">State</th>
            <th colSpan="4">YC Open</th>
            <th colSpan="4">YC DS</th>
            <th colSpan="4">YC BR</th>
          </tr>
          <tr className="sticky-header-second">
            <th className="sticky-header">Achieved till date</th>
            <th className="sticky-header">Achieved Last Calender Week</th>
            <th className="sticky-header">Achieved This Calender Week</th>
            <th className="sticky-header">% change</th>

            <th className="sticky-header">Achieved till date</th>
            <th className="sticky-header">Achieved Last Calender Week</th>
            <th className="sticky-header">Achieved This Calender Week</th>
            <th className="sticky-header">% change</th>

            <th className="sticky-header">Achieved till date</th>
            <th className="sticky-header">Achieved Last Calender Week</th>
            <th className="sticky-header">Achieved This Calender Week</th>
            <th className="sticky-header">% change</th>
          </tr>
        </thead>
        <tbody>
          {ycData.map((row, index) => (
            <tr key={index}>
              <td className="sticky-left">{row.state}</td>
              <td>{row.total_applications_open_YC}</td>
              <td>{row.open_last_week_YC}</td>
              <td>{row.this_week_open_applications_YC}</td>
              <td className={getPercentageClass(row.open_percentage_change_YC)}>{row.open_percentage_change_YC}</td>

              <td>{row.total_applications_submitted_YC}</td>
              <td>{row.submitted_last_week_YC}</td>
              <td>{row.this_week_DS_YC}</td>
              <td className={getPercentageClass(row.submitted_percentage_change_YC)}>{row.submitted_percentage_change_YC}</td>

              <td>{row.total_br_YC}</td>
              <td>{row.br_last_week_YC}</td>
              <td>{row.this_week_BR_YC}</td>
              <td className={getPercentageClass(row.br_percentage_change_YC)}>{row.br_percentage_change_YC}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </>
)}

</>
    )}
{!showCharts && (
  <>
      {/* ✅ MSME Table */}
 {/* MSME Table with This Week Columns */}
{!isLoadingMSME && msmeData.length > 0 && (
  <>
    <button className="export-btn" onClick={() => exportToExcel(msmeData, "MSME_Data")}>Export MSME Table</button>

    <div className="scroll-table-wrapper">
      <table className="achievement-table">
        <thead>
          <tr className="sticky-header-top">
            <th className="sticky-header sticky-left" rowSpan="2">State</th>
            <th colSpan="4">MSME Open</th>
            <th colSpan="4">MSME DS</th>
            <th colSpan="4">MSME BR</th>
          </tr>
          <tr className="sticky-header-second">
            <th className="sticky-header">Achieved till date</th>
            <th className="sticky-header">Achieved Last Calender Week</th>
            <th className="sticky-header">Achieved This Calender Week</th>
            <th className="sticky-header">% change</th>

            <th className="sticky-header">Achieved till date</th>
            <th className="sticky-header">Achieved Last Calender Week</th>
            <th className="sticky-header">Achieved This Calender Week</th>
            <th className="sticky-header">% change</th>

            <th className="sticky-header">Achieved till date</th>
            <th className="sticky-header">Achieved Last Calender Week</th>
            <th className="sticky-header">Achieved This Calender Week</th>
            <th className="sticky-header">% change</th>
          </tr>
        </thead>
        <tbody>
          {msmeData.map((row, index) => (
            <tr key={index}>
              <td className="sticky-left">{row.state}</td>
              <td>{row.total_applications_open_DI ?? 0}</td>
              <td>{row.open_last_week_DI ?? 0}</td>
              <td>{row.this_week_open_applications_DI ?? 0}</td>
              <td className={getPercentageClass(row.open_percentage_change_DI ?? 0)}>{row.open_percentage_change_DI ?? 0}</td>

              <td>{row.total_applications_submitted_DI ?? 0}</td>
              <td>{row.submitted_last_week_DI ?? 0}</td>
              <td>{row.this_week_DS_DI ?? 0}</td>
              <td className={getPercentageClass(row.submitted_percentage_change_DI ?? 0)}>{row.submitted_percentage_change_DI ?? 0}</td>

              <td>{row.total_br_DI ?? 0}</td>
              <td>{row.br_last_week_DI ?? 0}</td>
              <td>{row.this_week_BR_DI ?? 0}</td>
              <td className={getPercentageClass(row.br_percentage_change_DI ?? 0)}>{row.br_percentage_change_DI ?? 0}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </>
)}

</>
    )}
{!showCharts && (
  <>
      {/* Citizen Table */}
      {!isLoadingCitizen && citizenData.length > 0 && (
        <>
          <button className="export-btn" onClick={() => exportToExcel(citizenData, "Citizen_Data")}>
            Export Citizen Screened  Table
          </button>

          <div className="scroll-table-wrapper">
            <table className="achievement-table">
              <thead>
              <tr className="non-open-ds-br-header">

                  
                <th className="sticky-header sticky-left" rowSpan="2">State</th>
                  <th className="sticky-header">Total Citizen Screened</th>
                  <th className="sticky-header">This Calender Week Citizen Screened</th>
                  <th className="sticky-header">Last Calender Week Citizen Screened</th>
                  <th className="sticky-header">WoW Change %</th>
                  <th className="sticky-header">Last 7 Days  Citizen Screened</th>
                  <th className="sticky-header">Prior 7 Days Citizen Screened</th>
                  <th className="sticky-header">7 days Change %</th>
                  
                </tr>
              </thead>
              <tbody>
                {citizenData.map((row, index) => (
                  <tr key={index}>
                   
                   <td className="sticky-left">{row.state}</td>
                    <td>{row.total_citizen_screened}</td>
                    <td>{row.this_week_citizen_screened}</td>
                    <td>{row.last_week_citizen_screened}</td>
                    <td>{row.wow_change_percent}%</td>
                    <td>{row.last_7_days_citizen_screened}</td>
                    <td>{row.prior_7_days_citizen_screened}</td>
                    <td>{row.seven_day_change_percent}%</td>
                    
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
   
   </>
    )}
   {!showCharts && (
  <>
{/* ✅ MSME Reached Table */}
{!isLoadingMSMEReached && MSMEReachedData.length > 0 && (
  <>
    <button className="export-btn" onClick={() => exportToExcel(MSMEReachedData, "MSME_Data")}>
      Export MSME Screened Table
    </button>

    <div className="scroll-table-wrapper">
      <table className="achievement-table">
        <thead>
          <tr className="non-open-ds-br-header">
            
            <th className="sticky-header" rowSpan="2">State</th>
            <th className="sticky-header">Total MSME Reached/Screened</th>
            <th className="sticky-header">This Calender Week MSME</th>
            <th className="sticky-header">Last Calender Week MSME</th>
            <th className="sticky-header">WoW Change %</th>
            <th className="sticky-header">Last 7 Days MSME Screened</th>
            <th className="sticky-header">Prior 7 Days MSME Screened</th>
            <th className="sticky-header">7d Change %</th>
   
          </tr>
        </thead>
        <tbody>
          {MSMEReachedData.map((row, index) => (
            <tr key={index}>
              
              <td className="sticky-left">{row["state"]}</td>
              <td>{row.total_msme}</td>
              <td>{row.this_week_msme}</td>
              <td>{row.last_week_msme}</td>
              <td>{row.wow_change_percent}%</td>
              <td>{row.last_7_days_msme}</td>
              <td>{row.prior_7_days_msme}</td>
              <td>{row.seven_day_change_percent}%</td>
            
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </>
)}

</>
    )}
{!showCharts && (
  <>
    {/* ✅ HD Activity Table */}
{!isLoadingHD && hdData.length > 0 && (
    <>
    <button className="export-btn" onClick={() => exportToExcel(hdData, "HD_Activity_Data")}>Export Active HD Table</button>
   
  <div className="scroll-table-wrapper">
    <table className="achievement-table">
      <thead>
      <tr className="non-open-ds-br-header">
          <th className="sticky-header sticky-left">State</th>
          <th className="sticky-header">Total Active HD</th>
          <th className="sticky-header">Active Last Calender Week</th>
          <th className="sticky-header">Active This Calender Week</th>
          <th className="sticky-header">Weekly % Change</th>
          <th className="sticky-header">Active Last 7 Days</th>
          <th className="sticky-header">Active Prior 7 Days</th>
          <th className="sticky-header">7-Day % Change</th>
        </tr>
      </thead>
      <tbody>
        {hdData.map((row, index) => (
          <tr key={index}>
            <td className="sticky-left">{row["state"]}</td>
            <td>{row["Total Active HD"]}</td>
            <td>{row["Active Last Week"]}</td>
            <td>{row["Active This Week"]}</td>
            <td className={getPercentageClass(row["Weekly % Change"])}>
              {row["Weekly % Change"]}%
            </td>
            <td>{row["Active Last 7 Days"]}</td>
            <td>{row["Active Prior 7 Days"]}</td> 
            <td className={getPercentageClass(row["7-Day % Change"])}>
              {row["7-Day % Change"]}%
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
  </>
)}

</>
    )}
{!showCharts && (
  <>
{/* ✅ HD Trained Table */}
{!isLoadingHDTrained && hdTrainedData.length > 0 && (
   <>
   <button className="export-btn" onClick={() => exportToExcel(hdTrainedData, "HD_Trained_Data")}>Export HD Trained Table</button>
  
  <div className="scroll-table-wrapper">
    <table className="achievement-table">
      <thead>
      <tr className="non-open-ds-br-header">
          <th className="sticky-header sticky-left">State</th>
          <th className="sticky-header">Total Haqdarshaks Trained</th>
          <th className="sticky-header">Trained Last Calender Week</th>
          <th className="sticky-header">Trained This Calender Week</th>
          <th className="sticky-header">Weekly % Change</th>
          <th className="sticky-header">Trained Last 7 Days</th>
          <th className="sticky-header">Trained Prior 7 Days</th>
          <th className="sticky-header">7-Day % Change</th>
        </tr>
      </thead>
      <tbody>
        {hdTrainedData.map((row, index) => (
          <tr key={index}>
            <td className="sticky-left">{row["state"]}</td>
            <td>{row["Total Haqdarshaks Trained"]}</td>
            <td>{row["Trained Last Week"]}</td>
            <td>{row["Trained This Week"]}</td>
            <td className={getPercentageClass(row["Weekly % Change"])}>{row["Weekly % Change"]}%</td>
            <td>{row["Trained Last 7 Days"]}</td>
            <td>{row["Trained Prior 7 Days"]}</td>
            <td className={getPercentageClass(row["7-Day % Change"])}>{row["7-Day % Change"]}%</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
  </>
)}
</>
    )}

{!showCharts && (
  <>
{/* ✅ Trainers Trained Table */}
{!isLoadingTrainers && trainersData.length > 0 && (
  <>
  <button className="export-btn" onClick={() => exportToExcel(trainersData, "Trainers_Data")}>Export Trainers Trained Table</button>
 
  <div className="scroll-table-wrapper">
    <table className="achievement-table">
      <thead>
      <tr className="non-open-ds-br-header">
          <th className="sticky-header sticky-left">State</th>
          <th className="sticky-header">Total Trainers Trained</th>
          <th className="sticky-header">Trainers Last Calender Week</th>
          <th className="sticky-header">Trainers This Calender Week</th>
          <th className="sticky-header">Weekly % Change</th>
          <th className="sticky-header">Trainers Last 7 Days</th>
          <th className="sticky-header">Trainers Prior 7 Days</th>
          <th className="sticky-header">7-Day % Change</th>
        </tr>
      </thead>
      <tbody>
        {trainersData.map((row, index) => (
          <tr key={index}>  
            <td className="sticky-left">{row["state"]}</td>
            <td>{row["Total Trainers Trained"]}</td>
            <td>{row["Trainers Last Week"]}</td>
            <td>{row["Trainers This Week"]}</td>
            <td className={getPercentageClass(row["Weekly % Change"])}>{row["Weekly % Change"]}%</td>
            <td>{row["Trainers Last 7 Days"]}</td>
            <td>{row["Trainers Prior 7 Days"]}</td>
            <td className={getPercentageClass(row["7-Day % Change"])}>{row["7-Day % Change"]}%</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
  </>
)}

</>
    )}



{/* ✅ Benefit Value Received Table */}
{!showCharts && (
  <>
{!isLoadingBenefitValue && benefitValueData.length > 0 && (
  <>
    <button className="export-btn" onClick={() => exportToExcel(benefitValueData, "Benefit_Value_Data")}>
      Export Benefit Value Table
    </button>

    <div className="scroll-table-wrapper">
      <table className="achievement-table">
        <thead>
          <tr className="non-open-ds-br-header">
            
            <th className="sticky-header">State</th>
            <th className="sticky-header">Total Benefit Value Received</th>
            <th className="sticky-header">Benefit Last Calender Week</th>
            <th className="sticky-header">Benefit This Calender Week</th>
            <th className="sticky-header">Weekly % Change</th>
            <th className="sticky-header">Benefit Last 7 Days</th>
            <th className="sticky-header">Benefit Prior 7 Days</th>
            <th className="sticky-header">7-Day % Change</th>
           
          </tr>
        </thead>
        <tbody>
          {benefitValueData.map((row, index) => (
            <tr key={index}>
              
              <td className="sticky-left">{row["state"]}</td>
              <td>{row["Total Benefits Value Received - Citizen"]}</td>
              <td>{row["Benefit Last Week"]}</td>
              <td>{row["Benefit This Week"]}</td>
              <td className={getPercentageClass(row["Weekly % Change"])}>{row["Weekly % Change"]}%</td>
              <td>{row["Benefit Last 7 Days"]}</td>
              <td>{row["Benefit Prior 7 Days"]}</td>
              <td className={getPercentageClass(row["7-Day % Change"])}>{row["7-Day % Change"]}%</td>
             
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </>
)}

</>
    )}

    
    </div>
  );
  
};

export default StateViewTable;
